import React from "react";
import RichText from "./RichText";

/** Simple page hero — eyebrow, headline, optional lede. Left-aligned, generous. */
export default function PageHero({ eyebrow, title, lede, testId }) {
  return (
    <section
      className="relative container-narrow pt-24 pb-16 sm:pt-28 sm:pb-20"
      data-testid={testId || "page-hero"}
    >
      <div className="max-w-3xl animate-fade-up">
        {eyebrow && <RichText as="div" className="eyebrow mb-6" value={eyebrow} />}
        <RichText as="h1" className="display text-[42px] sm:text-[56px] lg:text-[64px]" value={title} />
        {lede && <RichText as="p" className="prose-qr mt-8 max-w-2xl" value={lede} />}
      </div>
      <span className="block mt-16 h-px w-24 bg-brand-ink/25" />
    </section>
  );
}
